


















import { computed, defineComponent, PropType } from '@vue/composition-api';
import Gender from './index';
import { GenderType } from '@ad/tt_ads_common_enums';

const name = 'ttam-gender-compose-flex';
export default defineComponent({
  name,
  components: {
    TtamGender: Gender.TtamGender,
  },
  props: {
    inputValue: {
      type: Number,
    },
    buttonWidth: {
      type: Number,
    },
    batchFormData: {
      type: Array as PropType<
        {
          name: string;
          title: string;
          value: GenderType;
        }[]
      >,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const _inputValue = computed({
      get: () => props.inputValue,
      set: val => {
        emit('change', val);
      },
    });
    return {
      name,
      _inputValue,
    };
  },
});
